import type { ValueOf } from '@evc/web-components';

export const passwordResetStatus = {
  SUCCESS: 'success',
  ERROR: 'error',
  CANCELED: 'canceled',
} as const;
export type PasswordResetStatus = ValueOf<typeof passwordResetStatus>;
